export default __webpack_public_path__ + "b8ec2d3ee6c87e6bb1dff914a4b079b9.svg";